module.exports = __webpack_public_path__ + "img/php-seeklogo.com 2.4d914927.svg";